// xpos: 730, ypos: 1075 (right-bottom)
// xpos: 50, ypos: 1070 (left-bottom)
// { page: 1, xpos: 505, ypos: 1085, skip: true },

export const qpt_numberpage_eng = [
  // { skip: true },
  { text: '', xpos: 730, ypos: 1088 },
  { text: 2, xpos: 50, ypos: 1088 },
  { text: 3, xpos: 730, ypos: 1088 },
  { text: 4, xpos: 50, ypos: 1088 },
  { text: 5, xpos: 730, ypos: 1088 },
  { text: 6, xpos: 50, ypos: 1088 },
  { text: 7, xpos: 730, ypos: 1088 },
  { text: 8, xpos: 50, ypos: 1088 },
  { text: 9, xpos: 730, ypos: 1088 },
  { text: 10, xpos: 50, ypos: 1088 },
  { text: 11, xpos: 730, ypos: 1088 },
  { text: 12, xpos: 50, ypos: 1088 },
  { text: 13, xpos: 730, ypos: 1088 },
  { text: 14, xpos: 50, ypos: 1088 },
  { text: 15, xpos: 730, ypos: 1088 },
  { text: 16, xpos: 50, ypos: 1088 },
  { text: 17, xpos: 730, ypos: 1088 },
  { text: 18, xpos: 50, ypos: 1088 },
  { text: 19, xpos: 730, ypos: 1088 },
  { text: 20, xpos: 50, ypos: 1088 },
  { text: 21, xpos: 730, ypos: 1088 },
  { text: 22, xpos: 50, ypos: 1088 },
  { text: 23, xpos: 730, ypos: 1088 },
  { text: 24, xpos: 50, ypos: 1088 },
  { text: 25, xpos: 730, ypos: 1088 },
  { text: 26, xpos: 50, ypos: 1088 },
  { text: 27, xpos: 730, ypos: 1088 },
  { text: 28, xpos: 50, ypos: 1088 },
  { text: 29, xpos: 730, ypos: 1088 },
  { text: 30, xpos: 50, ypos: 1088 },
  { text: 31, xpos: 730, ypos: 1088 },
  { text: 32, xpos: 50, ypos: 1088 },
  { text: 33, xpos: 730, ypos: 1088 },
  { text: 34, xpos: 50, ypos: 1088 },
  { text: 35, xpos: 730, ypos: 1088 },
  { text: 36, xpos: 50, ypos: 1088 },
  { text: 37, xpos: 730, ypos: 1088 },
  { text: 38, xpos: 50, ypos: 1088 },
  { text: 39, xpos: 730, ypos: 1088 },
  { text: 40, xpos: 50, ypos: 1088 },
  { text: 41, xpos: 730, ypos: 1088 },
  { text: 42, xpos: 50, ypos: 1088 },
  { text: 43, xpos: 730, ypos: 1088 },
];

export const qpt_numberpage_thai = [
  { text: 44, xpos: 50, ypos: 1088 },
  { text: 45, xpos: 730, ypos: 1088 },
  { text: 46, xpos: 50, ypos: 1088 },
  { text: 47, xpos: 730, ypos: 1088 },
  { text: 48, xpos: 50, ypos: 1088 },
  { text: 49, xpos: 730, ypos: 1088 },
  { text: 50, xpos: 50, ypos: 1088 },
  { text: 51, xpos: 730, ypos: 1088 },
  { text: 52, xpos: 50, ypos: 1088 },
  { text: 53, xpos: 730, ypos: 1088 },
  { text: 54, xpos: 50, ypos: 1088 },
  { text: 55, xpos: 730, ypos: 1088 },
  { text: 56, xpos: 50, ypos: 1088 },
  { text: 57, xpos: 730, ypos: 1088 },
  { text: 58, xpos: 50, ypos: 1088 },
  { text: 59, xpos: 730, ypos: 1088 },
  { text: 60, xpos: 50, ypos: 1088 },
  { text: 61, xpos: 730, ypos: 1088 },
  { text: 62, xpos: 50, ypos: 1088 },
  { text: 63, xpos: 730, ypos: 1088 },
  { text: 64, xpos: 50, ypos: 1088 },
  { text: 65, xpos: 730, ypos: 1088 },
  { text: 66, xpos: 50, ypos: 1088 },
  { text: 67, xpos: 730, ypos: 1088 },
  { text: 68, xpos: 50, ypos: 1088 },
  { text: 69, xpos: 730, ypos: 1088 },
  { text: 70, xpos: 50, ypos: 1088 },
  { text: 71, xpos: 730, ypos: 1088 },
  { text: 72, xpos: 50, ypos: 1088 },
  { text: 73, xpos: 730, ypos: 1088 },
  { text: 74, xpos: 50, ypos: 1088 },
  { text: 75, xpos: 730, ypos: 1088 },
  { text: 76, xpos: 50, ypos: 1088 },
  { text: 77, xpos: 730, ypos: 1088 },
  { text: 78, xpos: 50, ypos: 1088 },
  { text: 79, xpos: 730, ypos: 1088 },
  { text: 80, xpos: 50, ypos: 1088 },
  { text: 81, xpos: 730, ypos: 1088 },
  { text: 82, xpos: 50, ypos: 1088 },
  { text: 83, xpos: 730, ypos: 1088 },
  { text: 84, xpos: 50, ypos: 1088 },
  { text: 85, xpos: 730, ypos: 1088 },
  { text: 86, xpos: 50, ypos: 1088 },
  { text: 87, xpos: 730, ypos: 1088 },
  { text: 88, xpos: 50, ypos: 1088 },
  { text: 89, xpos: 730, ypos: 1088 },
  { text: 90, xpos: 50, ypos: 1088 },
  { text: 91, xpos: 730, ypos: 1088 },
  { text: 92, xpos: 50, ypos: 1088 },
  { text: 93, xpos: 730, ypos: 1088 },
  { text: 94, xpos: 50, ypos: 1088 },
  { text: 95, xpos: 730, ypos: 1088 },
  { text: 96, xpos: 50, ypos: 1088 }
];

// 9P Format
export const NineP_numberpage_eng = [
  { text: '', xpos: 396, ypos: 1070 },
  { text: 2, xpos: 396, ypos: 1070 },
  { text: 3, xpos: 396, ypos: 1070 },
  { text: 4, xpos: 396, ypos: 1070 },
  { text: 5, xpos: 396, ypos: 1070 },
  { text: 6, xpos: 396, ypos: 1070 },
  { text: 7, xpos: 396, ypos: 1070 },
  { text: 8, xpos: 396, ypos: 1070 },
  { text: 9, xpos: 396, ypos: 1070 },
  { text: 10, xpos: 396, ypos: 1070 },
  { text: 11, xpos: 396, ypos: 1070 },
  { text: 12, xpos: 396, ypos: 1070 },
  { text: 13, xpos: 396, ypos: 1070 },
  { text: 14, xpos: 396, ypos: 1070 },
  { text: 15, xpos: 396, ypos: 1070 },
  { text: 16, xpos: 396, ypos: 1070 },
  { text: 17, xpos: 396, ypos: 1070 },
  { text: 18, xpos: 396, ypos: 1070 },
  { text: 19, xpos: 396, ypos: 1070 },
  { text: 20, xpos: 396, ypos: 1070 },
  { text: 21, xpos: 396, ypos: 1070 },
  { text: 22, xpos: 396, ypos: 1070 },
  // { text: 23, xpos: 396, ypos: 1070 },
];

// NOTE: `xpos`/`ypos` are authoritative, `text` is advisory.
// PdfStaticModal computes the printed number from the page's position so that
// dynamically inserted pages (the supplement overflow page) renumber the rest.
// For Thai the run starts at englishPageCount + 1 — i.e. 23 for 9P, not the 19
// listed below, which was left behind when the English section grew to 22 pages.
export const NineP_numberpage_thai = [
  { text: 19, xpos: 396, ypos: 1070 },
  { text: 20, xpos: 396, ypos: 1070 },
  { text: 21, xpos: 396, ypos: 1070 },
  { text: 22, xpos: 396, ypos: 1070 },
  { text: 23, xpos: 396, ypos: 1070 },
  { text: 24, xpos: 396, ypos: 1085 },
  { text: 25, xpos: 396, ypos: 1070 },
  { text: 26, xpos: 396, ypos: 1070 },
  { text: 27, xpos: 396, ypos: 1070 },
  { text: 28, xpos: 396, ypos: 1070 },
  { text: 29, xpos: 396, ypos: 1070 },
  { text: 30, xpos: 396, ypos: 1070 },
  { text: 31, xpos: 396, ypos: 1070 },
  { text: 32, xpos: 396, ypos: 1070 },
  { text: 33, xpos: 396, ypos: 1070 },
  { text: 34, xpos: 396, ypos: 1070 },
  { text: 35, xpos: 396, ypos: 1070 },
  { text: 36, xpos: 396, ypos: 1070 },
  { text: 37, xpos: 396, ypos: 1070 },
  { text: 38, xpos: 396, ypos: 1070 },
  { text: 39, xpos: 396, ypos: 1070 },
  { text: 40, xpos: 396, ypos: 1070 },
  { text: 41, xpos: 396, ypos: 1070 },
  { text: 42, xpos: 396, ypos: 1070 },
  { text: 43, xpos: 396, ypos: 1070 },
  { text: 44, xpos: 396, ypos: 1070 },
  { text: 45, xpos: 396, ypos: 1070 },
  { text: 46, xpos: 396, ypos: 1070 },
  { text: 47, xpos: 396, ypos: 1070 },
  { text: 48, xpos: 396, ypos: 1070 },
  { text: 49, xpos: 396, ypos: 1070 },
  // { text: 50, xpos: 396, ypos: 1070 },
  // { text: 51, xpos: 396, ypos: 1070 },
];

// AS Format
export const as_numberpage_eng = [
    // { skip: true },
    { text: '', xpos: 396, ypos: 1085 },
    { text: 2, xpos: 396, ypos: 1085 },
    { text: 3, xpos: 396, ypos: 1085 },
    { text: 4, xpos: 396, ypos: 1085 },
    { text: 5, xpos: 396, ypos: 1085 },
    { text: 6, xpos: 396, ypos: 1085 },
    { text: 7, xpos: 396, ypos: 1085 },
    { text: 8, xpos: 396, ypos: 1085 },
    { text: 9, xpos: 396, ypos: 1085 },
    { text: 10, xpos: 396, ypos: 1085 },
    { text: 11, xpos: 396, ypos: 1085 },
    { text: 12, xpos: 396, ypos: 1085 },
    { text: 13, xpos: 396, ypos: 1085 },
    { text: 14, xpos: 396, ypos: 1085 },
    { text: 15, xpos: 396, ypos: 1085 },
    { text: 16, xpos: 396, ypos: 1085 },
    { text: 17, xpos: 396, ypos: 1085 },
    { text: 18, xpos: 396, ypos: 1085 },
];

export const as_numberpage_thai = [
  { text: 19, xpos: 396, ypos: 1085 },
  { text: 20, xpos: 396, ypos: 1085 },
  { text: 21, xpos: 396, ypos: 1085 },
  { text: 22, xpos: 396, ypos: 1085 },
  { text: 23, xpos: 396, ypos: 1085 },
  { text: 24, xpos: 396, ypos: 1085 },
  { text: 25, xpos: 396, ypos: 1085 },
  { text: 26, xpos: 396, ypos: 1085 },
  { text: 27, xpos: 396, ypos: 1085 },
  { text: 28, xpos: 396, ypos: 1085 },
  { text: 29, xpos: 396, ypos: 1085 },
  { text: 30, xpos: 396, ypos: 1085 },
  { text: 31, xpos: 396, ypos: 1085 },
  { text: 32, xpos: 396, ypos: 1085 },
  { text: 33, xpos: 396, ypos: 1085 },
  { text: 34, xpos: 396, ypos: 1085 },
  { text: 35, xpos: 396, ypos: 1085 },
  { text: 36, xpos: 396, ypos: 1085 },
  { text: 37, xpos: 396, ypos: 1085 },
  { text: 38, xpos: 396, ypos: 1085 },
  { text: 39, xpos: 396, ypos: 1085 },
  { text: 40, xpos: 396, ypos: 1085 },
  { text: 41, xpos: 396, ypos: 1085 },
  { text: 42, xpos: 396, ypos: 1085 },
  { text: 43, xpos: 396, ypos: 1085 },
  { text: 44, xpos: 396, ypos: 1085 }
];

// Toxin Format
export const toxin_numberpage_eng = [
  // { skip: true },
  { text: '', xpos: 396, ypos: 1085 },
  { text: 2, xpos: 396, ypos: 1085 },
  { text: 3, xpos: 396, ypos: 1085 },
  { text: 4, xpos: 396, ypos: 1085 },
  { text: 5, xpos: 396, ypos: 1085 },
  { text: 6, xpos: 396, ypos: 1085 },
  { text: 7, xpos: 396, ypos: 1085 },
  { text: 8, xpos: 396, ypos: 1085 },
  { text: 9, xpos: 396, ypos: 1085 },
  { text: 10, xpos: 396, ypos: 1085 },
  { text: 11, xpos: 396, ypos: 1085 },
  { text: 12, xpos: 396, ypos: 1085 },
  { text: 13, xpos: 396, ypos: 1085 },
  { text: 14, xpos: 396, ypos: 1085 },
  { text: 15, xpos: 396, ypos: 1085 },
  { text: 16, xpos: 396, ypos: 1085 },
  { text: 17, xpos: 396, ypos: 1085 },
  { text: 18, xpos: 396, ypos: 1085 }
];

export const toxin_numberpage_thai = [
  { text: 19, xpos: 396, ypos: 1085 },
  { text: 20, xpos: 396, ypos: 1085 },
  { text: 21, xpos: 396, ypos: 1085 },
  { text: 22, xpos: 396, ypos: 1085 },
  { text: 23, xpos: 396, ypos: 1085 },
  { text: 24, xpos: 396, ypos: 1085 },
  { text: 25, xpos: 396, ypos: 1085 },
  { text: 26, xpos: 396, ypos: 1085 },
  { text: 27, xpos: 396, ypos: 1085 },
  { text: 28, xpos: 396, ypos: 1085 },
  { text: 29, xpos: 396, ypos: 1085 },
  { text: 30, xpos: 396, ypos: 1085 },
  { text: 31, xpos: 396, ypos: 1085 },
  { text: 32, xpos: 396, ypos: 1085 },
  { text: 33, xpos: 396, ypos: 1085 },
  { text: 34, xpos: 396, ypos: 1085 },
  { text: 35, xpos: 396, ypos: 1085 },
  { text: 36, xpos: 396, ypos: 1085 },
  { text: 37, xpos: 396, ypos: 1085 },
  { text: 38, xpos: 396, ypos: 1085 },
  { text: 39, xpos: 396, ypos: 1085 },
  { text: 40, xpos: 396, ypos: 1085 },
  { text: 41, xpos: 396, ypos: 1085 },
  { text: 42, xpos: 396, ypos: 1085 },
  { text: 43, xpos: 396, ypos: 1085 },
  { text: 44, xpos: 396, ypos: 1085 }
];

// OMs Format
export const oms_numberpage_eng = [
  // { skip: true },
  { text: '', xpos: 396, ypos: 1085 },
  { text: 2, xpos: 396, ypos: 1085 },
  { text: 3, xpos: 396, ypos: 1085 },
  { text: 4, xpos: 396, ypos: 1085 },
  { text: 5, xpos: 396, ypos: 1085 },
  { text: 6, xpos: 396, ypos: 1085 },
  { text: 7, xpos: 396, ypos: 1085 },
  { text: 8, xpos: 396, ypos: 1085 },
  { text: 9, xpos: 396, ypos: 1085 },
  { text: 10, xpos: 396, ypos: 1085 },
  { text: 11, xpos: 396, ypos: 1085 },
  { text: 12, xpos: 396, ypos: 1085 },
  { text: 13, xpos: 396, ypos: 1085 },
  { text: 14, xpos: 396, ypos: 1085 },
  { text: 15, xpos: 396, ypos: 1085 },
  { text: 16, xpos: 396, ypos: 1085 },
  { text: 17, xpos: 396, ypos: 1085 },
  { text: 18, xpos: 396, ypos: 1085 },
  { text: 19, xpos: 396, ypos: 1085 }
];

export const oms_numberpage_thai = [
  { text: 20, xpos: 396, ypos: 1085 },
  { text: 21, xpos: 396, ypos: 1085 },
  { text: 22, xpos: 396, ypos: 1085 },
  { text: 23, xpos: 396, ypos: 1085 },
  { text: 24, xpos: 396, ypos: 1085 },
  { text: 25, xpos: 396, ypos: 1085 },
  { text: 26, xpos: 396, ypos: 1085 },
  { text: 27, xpos: 396, ypos: 1085 },
  { text: 28, xpos: 396, ypos: 1085 },
  { text: 29, xpos: 396, ypos: 1085 },
  { text: 30, xpos: 396, ypos: 1085 },
  { text: 31, xpos: 396, ypos: 1085 },
  { text: 32, xpos: 396, ypos: 1085 },
  { text: 33, xpos: 396, ypos: 1085 },
  { text: 34, xpos: 396, ypos: 1085 },
  { text: 35, xpos: 396, ypos: 1085 },
  { text: 36, xpos: 396, ypos: 1085 },
  { text: 37, xpos: 396, ypos: 1085 },
  { text: 38, xpos: 396, ypos: 1085 },
  { text: 39, xpos: 396, ypos: 1085 },
  { text: 40, xpos: 396, ypos: 1085 },
  { text: 41, xpos: 396, ypos: 1085 },
  { text: 42, xpos: 396, ypos: 1085 },
  { text: 43, xpos: 396, ypos: 1085 },
  { text: 44, xpos: 396, ypos: 1085 },
  { text: 45, xpos: 396, ypos: 1085 },
  { text: 46, xpos: 396, ypos: 1085 }
];

// BWC-allergy Format
export const bwcallergy_numberpage_eng = [
    // { skip: true },
    { text: '', xpos: 396, ypos: 1080 },
    { text: 2, xpos: 396, ypos: 1080 },
    { text: 3, xpos: 396, ypos: 1080 },
    { text: 4, xpos: 396, ypos: 1080 },
    { text: 5, xpos: 396, ypos: 1080 },
    { text: 6, xpos: 396, ypos: 1080 },
    { text: 7, xpos: 396, ypos: 1080 },
    { text: 8, xpos: 396, ypos: 1080 },
    { text: 9, xpos: 396, ypos: 1080 },
    { text: 10, xpos: 396, ypos: 1080 },
    { text: 11, xpos: 396, ypos: 1080 },
    { text: 12, xpos: 396, ypos: 1080 },
    { text: 13, xpos: 396, ypos: 1080 },
    { text: 14, xpos: 396, ypos: 1080 },
    { text: 15, xpos: 396, ypos: 1080 },
    { text: 16, xpos: 396, ypos: 1080 },
    { text: 17, xpos: 396, ypos: 1080 },
    { text: 18, xpos: 396, ypos: 1080 },
    { text: 19, xpos: 396, ypos: 1080 },
    { text: 20, xpos: 396, ypos: 1080 },
];

export const bwcallergy_numberpage_thai = [
    { text: 21, xpos: 396, ypos: 1080 },
    { text: 22, xpos: 396, ypos: 1080 },
    { text: 23, xpos: 396, ypos: 1080 },
    { text: 24, xpos: 396, ypos: 1080 },
    { text: 25, xpos: 396, ypos: 1080 },
    { text: 26, xpos: 396, ypos: 1080 },
    { text: 27, xpos: 396, ypos: 1080 },
    { text: 28, xpos: 396, ypos: 1080 },
    { text: 29, xpos: 396, ypos: 1080 },
    { text: 30, xpos: 396, ypos: 1080 },
    { text: 31, xpos: 396, ypos: 1080 },
    { text: 32, xpos: 396, ypos: 1080 },
    { text: 33, xpos: 396, ypos: 1080 },
    { text: 34, xpos: 396, ypos: 1080 },
    { text: 35, xpos: 396, ypos: 1080 },
    { text: 36, xpos: 396, ypos: 1080 },
    { text: 37, xpos: 396, ypos: 1080 },
    { text: 38, xpos: 396, ypos: 1080 },
    { text: 39, xpos: 396, ypos: 1080 },
    { text: 40, xpos: 396, ypos: 1080 },
    { text: 41, xpos: 396, ypos: 1080 },
    { text: 42, xpos: 396, ypos: 1080 },
    { text: 43, xpos: 396, ypos: 1080 },
    { text: 44, xpos: 396, ypos: 1080 },
    { text: 45, xpos: 396, ypos: 1080 }
];

// BWC-core Format
export const bwccore_numberpage_eng = [
    // { skip: true },
    { text: '', xpos: 396, ypos: 1080 },
    { text: 2, xpos: 396, ypos: 1080 },
    { text: 3, xpos: 396, ypos: 1080 },
    { text: 4, xpos: 396, ypos: 1080 },
    { text: 5, xpos: 396, ypos: 1080 },
    { text: 6, xpos: 396, ypos: 1080 },
    { text: 7, xpos: 396, ypos: 1080 },
    { text: 8, xpos: 396, ypos: 1080 },
    { text: 9, xpos: 396, ypos: 1080 },
    { text: 10, xpos: 396, ypos: 1080 },
    { text: 11, xpos: 396, ypos: 1080 },
    { text: 12, xpos: 396, ypos: 1080 },
    { text: 13, xpos: 396, ypos: 1080 },
    { text: 14, xpos: 396, ypos: 1080 },
    { text: 15, xpos: 396, ypos: 1080 },
    { text: 16, xpos: 396, ypos: 1080 },
    { text: 17, xpos: 396, ypos: 1080 },
    { text: 18, xpos: 396, ypos: 1080 },
    { text: 19, xpos: 396, ypos: 1080 },
    { text: 20, xpos: 396, ypos: 1080 },
    { text: 21, xpos: 396, ypos: 1080 },
];

export const bwccore_numberpage_thai = [
    { text: 22, xpos: 396, ypos: 1080 },
    { text: 23, xpos: 396, ypos: 1080 },
    { text: 24, xpos: 396, ypos: 1080 },
    { text: 25, xpos: 396, ypos: 1080 },
    { text: 26, xpos: 396, ypos: 1080 },
    { text: 27, xpos: 396, ypos: 1080 },
    { text: 28, xpos: 396, ypos: 1080 },
    { text: 29, xpos: 396, ypos: 1080 },
    { text: 30, xpos: 396, ypos: 1080 },
    { text: 31, xpos: 396, ypos: 1080 },
    { text: 32, xpos: 396, ypos: 1080 },
    { text: 33, xpos: 396, ypos: 1080 },
    { text: 34, xpos: 396, ypos: 1080 },
    { text: 35, xpos: 396, ypos: 1080 },
    { text: 36, xpos: 396, ypos: 1080 },
    { text: 37, xpos: 396, ypos: 1080 },
    { text: 38, xpos: 396, ypos: 1080 },
    { text: 39, xpos: 396, ypos: 1080 },
    { text: 40, xpos: 396, ypos: 1080 },
    { text: 41, xpos: 396, ypos: 1080 },
    { text: 42, xpos: 396, ypos: 1080 },
    { text: 43, xpos: 396, ypos: 1080 },
    { text: 44, xpos: 396, ypos: 1080 },
    { text: 45, xpos: 396, ypos: 1080 },
    { text: 46, xpos: 396, ypos: 1080 },
    { text: 47, xpos: 396, ypos: 1080 }
];

// BWC-diamond Format
export const bwcdiamond_numberpage_eng = [
    // { skip: true },
    { text: '', xpos: 396, ypos: 1080 },
    { text: 2, xpos: 396, ypos: 1080 },
    { text: 3, xpos: 396, ypos: 1080 },
    { text: 4, xpos: 396, ypos: 1080 },
    { text: 5, xpos: 396, ypos: 1080 },
    { text: 6, xpos: 396, ypos: 1080 },
    { text: 7, xpos: 396, ypos: 1080 },
    { text: 8, xpos: 396, ypos: 1080 },
    { text: 9, xpos: 396, ypos: 1080 },
    { text: 10, xpos: 396, ypos: 1080 },
    { text: 11, xpos: 396, ypos: 1080 },
    { text: 12, xpos: 396, ypos: 1080 },
    { text: 13, xpos: 396, ypos: 1080 },
    { text: 14, xpos: 396, ypos: 1080 },
    { text: 15, xpos: 396, ypos: 1080 },
    { text: 16, xpos: 396, ypos: 1080 },
    { text: 17, xpos: 396, ypos: 1080 },
    { text: 18, xpos: 396, ypos: 1080 },
    { text: 19, xpos: 396, ypos: 1080 },
    { text: 20, xpos: 396, ypos: 1080 },
    { text: 21, xpos: 396, ypos: 1080 },
    { text: 22, xpos: 396, ypos: 1080 },
    { text: 23, xpos: 396, ypos: 1080 },
    { text: 24, xpos: 396, ypos: 1080 },
    { text: 25, xpos: 396, ypos: 1080 },
    { text: 26, xpos: 396, ypos: 1080 },
];

export const bwcdiamond_numberpage_thai = [
    { text: 27, xpos: 396, ypos: 1080 },
    { text: 28, xpos: 396, ypos: 1080 },
    { text: 29, xpos: 396, ypos: 1080 },
    { text: 30, xpos: 396, ypos: 1080 },
    { text: 31, xpos: 396, ypos: 1080 },
    { text: 32, xpos: 396, ypos: 1080 },
    { text: 33, xpos: 396, ypos: 1080 },
    { text: 34, xpos: 396, ypos: 1080 },
    { text: 35, xpos: 396, ypos: 1080 },
    { text: 36, xpos: 396, ypos: 1080 },
    { text: 37, xpos: 396, ypos: 1080 },
    { text: 38, xpos: 396, ypos: 1080 },
    { text: 39, xpos: 396, ypos: 1080 },
    { text: 40, xpos: 396, ypos: 1080 },
    { text: 41, xpos: 396, ypos: 1080 },
    { text: 42, xpos: 396, ypos: 1080 },
    { text: 43, xpos: 396, ypos: 1080 },
    { text: 44, xpos: 396, ypos: 1080 },
    { text: 45, xpos: 396, ypos: 1080 },
    { text: 46, xpos: 396, ypos: 1080 },
    { text: 47, xpos: 396, ypos: 1080 },
    { text: 48, xpos: 396, ypos: 1080 },
    { text: 49, xpos: 396, ypos: 1080 },
    { text: 50, xpos: 396, ypos: 1080 },
    { text: 51, xpos: 396, ypos: 1080 },
    { text: 52, xpos: 396, ypos: 1080 },
    { text: 53, xpos: 396, ypos: 1080 },
    { text: 54, xpos: 396, ypos: 1080 },
    { text: 55, xpos: 396, ypos: 1080 },
    { text: 56, xpos: 396, ypos: 1080 },
    { text: 57, xpos: 396, ypos: 1080 },
    { text: 58, xpos: 396, ypos: 1080 },
    { text: 59, xpos: 396, ypos: 1080 },
];